<template>
  <PbBasicView no-min-height>
    <UiDropzone
      v-model="files"
      :file-types="types"
      :disabled="pending"
    />
    <FlexBox
      direction="row"
      alignement="center"
    >
      <ControlButton
        :to="{ name: routeNames.Home }"
        :disabled="pending"
        :tooltip="translate('pb2.importView.backTooltip')"
        tooltip-location="bottom"
        class="pb-create-profile-link"
        :aria-label="translate('pb2.importView.backTooltip')"
        :label="translate('pb2.importView.backLabel')"
      />
      <ControlButton
        :tooltip="translate('pb2.importView.continueTooltip')"
        tooltip-location="bottom"
        class="btn-success"
        :aria-label="translate('pb2.importView.continueTooltip')"
        :label="translate('pb2.importView.continueLabel')"
        :disabled="!idle || !files.length"
        :is-loading="pending"
        @click="process"
      />
    </FlexBox>
  </PbBasicView>
</template>

<script setup>
import useHotkeys, { KEYS } from '@nicolaudie-group/ng-ui-kit/composables/useHotkeys'
import useFileReader from '@nicolaudie-group/ng-ui-kit/composables/useFileReader'
import ControlButton from '@nicolaudie-group/ng-ui-kit/components/ControlButton/ControlButton.vue'
import FlexBox from '@nicolaudie-group/ng-ui-kit/components/FlexBox/FlexBox.vue'
import UiDropzone from '@nicolaudie-group/ng-ui-kit/components/UiDropzone/UiDropzone.vue'
import useProfileStore from '@/stores/profile.store'
import useRouterStore from '@/stores/router.store'
import routeNames from '@/router/names'
import { watch } from 'vue'
import PbBasicView from '@/components/PbBasicView.vue'
import useTranslate from '@/composables/useTranslate'

const { translate } = useTranslate()

const types = [
  {
    mimeType: 'application/x-ssl2',
    ext: '.ssl2',
    typeName: 'ssl2',
    title: 'Profile Library 2',
  },
  // {
  //   mimeType: 'application/x-wolfmix-profile',
  //   ext: '.wmp',
  //   typeName: 'wolfmix_profile',
  //   title: 'Wolfmix profile',
  // },
]

const profileStore = useProfileStore()
const routerStore = useRouterStore()

/**
 * @param {import('@nicolaudie-group/ng-ui-kit/types').FileInstance} file
 */
async function upload(file) {
  if (file && file.content) {
    // let dataType = 'ssl2b64' // Default encode SSL2 (base64)
    // if (file.extension === 'wmp') dataType = 'wmpb64' // Wolfmix Profile (encoded)

    const profile = await profileStore.create({
      name: file.name,
      dataType: 'ssl2b64', // Default encode SSL2 (base64)
      data: file.content.base64,
    })

    if (!profile) {
      throw new Error(translate('pb2.importView.uploadFailed'))
    }

    const { uid } = profile

    await routerStore.push({
      name: routeNames.Create,
      params: {
        source: 'import',
        profileUid: uid,
      },
    })
  }
}

const {
  files,
  idle,
  pending,
  process,
} = useFileReader({
  auto: false,
  // Trigger the upload when fileReader finished reading the file
  callback: upload,
})

const { active: enterPressed } = useHotkeys(KEYS.Enter, {
  shift: false,
  alt: false,
  meta: false,
  ctrl: false,
  exact: true,
})

watch(enterPressed, () => {
  if (enterPressed.value) {
    process()
  }
})
</script>
